import React from 'react';

/**
 * Simple CSS-columns masonry. Renders children in vertical columns.
 * Children should be cards with their own background/border.
 */
export const MasonryGrid = ({ children, gap = '0.5rem', testid = 'masonry' }) => {
  return (
    <div data-testid={testid} className="columns-2 sm:columns-3 [column-fill:_balance]" style={{ columnGap: gap }}>
      {React.Children.map(children, (child, i) => (
        <div className="mb-2 break-inside-avoid" key={i}>{child}</div>
      ))}
    </div>
  );
};
